export const v = {
    PAGE_TITLE : "SpaceFlight.Go",


    scale: 100000000, // scale the size 1km = 10000 units
    
    orbitScale: 10000000,
    posX: 10000000, // scale size wrt to center 1km = 

    // Define the size scaling factor (1 km in real world = 0.001 units in the scene)
    sizeScalingFactor : 0.01,

    // Define the distance scaling factor (1 km in real world = 0.001 units in the scene)
    distanceScalingFactor : 0.0005,
}